const initCollectionDescription = () => {
  const toggleEl = document.querySelector('[data-collection-description-toggle]');
  if (!toggleEl) return;

  const scope = toggleEl.parentElement;
  if (!scope) return;

  const descriptionShortEl = scope.querySelector('[data-collection-description-short]');
  const descriptionFullEl = scope.querySelector('[data-collection-description-full]');
  if (!descriptionShortEl || !descriptionFullEl) return;

  const toggleShortTextEl = toggleEl.querySelector('[data-collection-description-toggle-short]');
  const toggleFullTextEl = toggleEl.querySelector('[data-collection-description-toggle-full]');

  const toggleHidden = () => {
    [descriptionShortEl, descriptionFullEl, toggleShortTextEl, toggleFullTextEl].forEach(el => {
      el?.classList.toggle('hidden');
    });
  };

  toggleEl.addEventListener('click', toggleHidden);
};

export default initCollectionDescription;
